<div class="page-layout blank fullwidth p-12" style="height: 1px; overflow-y: scroll; top: 1px;" >

  <div [ngClass]="isMobile ? 'containerMobile' : 'container'" *ngIf="!invoiceOpenItem">
    <div>
      <div class="header" >
        <i class="material-icons" style="color: black; float: left; cursor: pointer;margin-top: 0px; width: 3%;" (click)="goBack()" >keyboard_backspace</i> 
        <span class="title">Job Card Details <span class="request-number">#{{ request?.jobCard?.id}}</span></span>
        <div class="right">
          <div class="changebtn" >
            <div *ngFor="let status of filters.jobCardStatus" >
              <label class="{{status.statusclass}} "  *ngIf=" status.value==request?.jobCard?.jobcardStatus" >{{status.label}}</label>  

            </div>
            <i class="material-iconsMore" *ngIf=" request?.jobCard?.jobcardStatus== 4 ||  request?.jobCard?.jobcardStatus== 5 || request?.jobCard?.jobcardStatus== 6 || request?.jobCard?.jobcardStatus== 7"  (click)="openMenu()">more_vert</i>

            </div>
            <button mat-icon-button (click)="toggle()" style="background: #e9e9e9;" class="buttonMore">
              <mat-icon [ngClass]="{ 'rotated': isOpen }" class="expand_more">expand_more</mat-icon>
            </button>
            <div class="overlay" [class.visible]="openSideShow" (click)="closePopup()"></div>
            <ul class="openSideShow" *ngIf="openSideShow">
              <li (click)="markReady()" *ngIf="request?.jobCard?.jobcardStatus==4">Mark Ready To Deliver</li>
              <!-- (click)="shareDeails()" -->
              <!-- <li  *ngIf="request?.jobCard?.jobcardStatus==5">Send Status Update</li> -->
              <li (click)="invoiceOpen()" *ngIf="request?.jobCard?.jobcardStatus==5">Create Invoice</li>
              <!-- (click)="sendFeedback()" -->
              <li *ngIf="(request?.jobCard?.jobcardStatus == 5 || request?.jobCard?.jobcardStatus == 6 || request?.jobCard?.jobcardStatus == 7) && !request?.jobCard?.rating" (click)="sendFeedback()">Get Feedback</li>
              <li *ngIf="request?.jobCard?.rating" style="color: black; cursor: default;">Feedback Received</li>
            </ul>
              <div class="overlay" [class.visible]="PopupOpen" (click)="closePopup()"></div>
              <div class="popup" *ngIf="PopupOpen">
                <div class="popup-content order-success-sec">
                    <i class="material-icons" class="close-btn" (click)="closePopup()">close</i>
                          <h3>You have pending quote items. Are you sure you want to proceed?</h3>
                          <div class="popup-buttons">
                            <button class="no-btn" (click)="closePopup()">No</button>
                            <button class="yes-btn" (click)="updateInfo()">Yes</button>
                          </div>
                </div>
              </div>
        </div>
      </div>
      <div class="border" *ngIf="isOpen">
      <div style="display: flex;">
        <div class="jobcard-new-tag" *ngIf="request?.jobCard?.isExistingCustomer === true">
          Repeat Customer
        </div>
        <div class="jobcard-tag" *ngIf="request?.jobCard?.isExistingCustomer === false">
          New Customer
        </div>

        <div class="more_vert" *ngIf="request?.jobCard?.isExistingCustomer === true">
          <button class="history-btn" (click)="openServiceHistory()">Service History</button>
         </div>
      </div>

      <div class="details">
        <div class="logo-and-model">
          <img [src]="getMakeImageUrl(request?.jobCard?.make)" alt="Car Make Image" class="model-icon">
          <div class="model-info">
            <div class="jobcard-header">
              <div style="display: flex;">
                <span class="model-name">{{ request?.jobCard?.make || 'Unknown Make' }}</span>
              </div>    
            </div> 
            <span class="model-details">{{ request?.jobCard?.model || 'Unknown Model' }}, {{ request?.jobCard?.fuelType || 'Unknown Fuel Type' }}</span>
            <span class="model-details">{{ request?.jobCard?.registrationNumber }}</span>
            <span class="model-details" *ngIf="request?.jobCard?.vinNumber">{{ request?.jobCard?.vinNumber }}</span>
          </div>
        </div>

    
        <div class="right-details">
          <div class="timestamp" style="MARGIN-TOP: -37PX;" *ngIf="request?.jobCard?.rating <= 0">{{ request?.jobCard?.createdAt| date:'dd MMM yyyy, h:mm a': 'GMT+1060' }}</div> 

          <div style="position: relative;">
            <div *ngIf="request?.jobCard?.rating > 0" class="food-rating">
              <div class="ratingss">Your Service Rating</div>
                <div class="rating">
                    <span class="star">&#9733;</span>
                    <span class="score">{{ request?.jobCard?.rating  }}</span>
                    <div *ngIf="request?.jobCard?.feedback !==null" class="toolbar-separator"></div>
                    <!-- <div *ngIf="jobCard.feedback !== null" class="toolbar-separator"></div> -->
                    <span class="review">{{ request?.jobCard?.feedback }}</span>
                    <span class="review">
                      {{ request?.jobCard?.rating === 1 ? 'Terrible' : 
                      request?.jobCard.rating === 2 ? 'Bad' : 
                      request?.jobCard.rating === 3 ? 'Disappointing' : 
                      request?.jobCard.rating === 4 ? 'Pleasant' : 
                      request?.jobCard.rating === 5 ? 'Awesome' : 'Not Rated' }}
                  </span>
                </div>
                <div class="timestamp">{{ request?.jobCard?.createdAt| date:'dd MMM yyyy, h:mm a': 'GMT+1060' }}</div> 
            </div> 
            <!-- <div class="timestamp" *ngIf="request?.jobCard?.rating <= 0">{{ request?.jobCard?.createdAt| date:'dd MMM yyyy, h:mm a': 'GMT+1060' }}</div>  -->
             <!-- Template for Get Feedback Button -->
    <!-- <ng-template #getFeedback> -->
      <div>
        <!-- (click)="sendFeedback(request?.jobCard?.id, request?.jobCard?.jobcardStatus)" -->
        <button  class="ghost-button" style="color: 144579;"
          *ngIf="(request?.jobCard?.jobcardStatus === 5 || request?.jobCard?.jobcardStatus === 6 || request?.jobCard?.jobcardStatus === 7) && !request?.jobCard?.rating"
          (click)="sendFeedback(request?.jobCard?.id, request?.jobCard?.jobcardStatus)"
          >
          Get Feedback
        </button>
         </div>
    <!-- </ng-template> -->
          </div>
    </div>
    </div>
  </div>
          <!-- <ul class="openSideShow" *ngIf="openSideShow">
            <li (click)="markReady()" *ngIf="request?.jobCard?.jobcardStatus==3">Mark Ready To Deliver</li>
            <li (click)="shareDeails()" *ngIf="request?.jobCard?.jobcardStatus==4">Send Status Update</li>
            <li (click)="invoiceOpen()" *ngIf="request?.jobCard?.jobcardStatus==4">Create Invoice</li>
            
          </ul> -->
 
          


          <!-- <div class="timestamp">{{ request?.jobCard?.createdAt| date:'dd MMM yyyy, h:mm a': 'GMT+1060' }}</div> -->

        
     
    
  </div>
     
  </div>
  <div id="myDynamicSec" #myDynamicSec></div>
  <div class="overlay" [class.visible]="sidebarOpenInvoice" (click)="CloseSidebar()" ></div>

  <div class="sidebar1" *ngIf="sidebarOpenInvoice">
    <mat-list>
        <header>
          <div class="back-button">
            <i (click)="CloseSidebar()" class="material-icons-arrowback">arrow_back</i>
            <span class="title1">Create Invoice</span>
            <div *ngIf="quoteId">
              <h2>{{ quoteId }}</h2>
            </div>
          </div>
        </header>
        <div class="detailsQuote">
          <div style="padding: 0px 15px;">
            <div class="logoModel" >
              <img [src]="getMakeImageUrl(request?.jobCard?.make)" alt="Car Make Image" class="img">
              <div class="model-info">
                <span class="model-name">{{ request?.jobCard?.make || 'Unknown Make' }}</span>
                <span class="model-details">{{ request?.jobCard?.model || 'Unknown Model' }}, {{ request?.jobCard?.fuelType || 'Unknown Fuel Type' }}</span>
                <span class="model-details">{{ request?.jobCard?.registrationNumber }}</span>
                <span class="model-details">{{ request?.jobCard?.vinNumber || '' }}</span>
              </div>
            </div>
          </div>
        <!-- <mat-divider></mat-divider> -->
        <div  *ngIf="customerQuotation?.length > 0; else noQuotesApproved">
          <div  class="items" style="margin-bottom: 56px;" >
            <!-- <div class="request-info">Quote received for {{itemLength?.length}} items </div> -->
            <div class="item" >
              <div class="checkboxselect">
                <input type="checkbox" [checked]="selectAllQuote" (change)="sidebarToggleSelectAllQuote()">
                <span>Select All</span>
              </div>
              <div class="grand-total" style="text-align: end;">
                <span class="customer-quote-price">₹ {{quoteGrandTotal | number:'1.0-0'}}</span>
                <div class="quote_total_amount">Total Amount</div>
              </div>
            </div>
            <div class="spare-part-header">
            <h2 style="font-weight: bold;">Spare Parts</h2>
            <p style="margin-top:23px;color:#144579;cursor:pointer;" (click)="AddItems()" *ngIf="customerQuotation.length>0">Add More</p>
          </div>
          <div style="padding: 0px 15px; margin-bottom: 150px;">
            <div class="quotereceived-items" *ngFor="let quote of customerQuotation; let i = index" [ngClass]="{'border-box': quote.selected}">
                
              <div class="lines" style="display: flex;">
                <div style="width:5%">
                  <input class="checkbox-spare" type="checkbox" [(ngModel)]="quote.selected" (change)="sidebarToggleItemSelectionQuote()">
                </div>
                <div style="width:85%">
                  <span class="part-name" style="width: 100%;">{{quote.itemName}}</span>
                </div>
                <div style="width:10%">
                  <i class="material-icons-spare" (click)="openEditDialog(quote)">edit</i> 
                </div>                 
                </div>


                <!-- <div class="lines" style="display: flex;">
                  <input class="checkbox-spare" type="checkbox" [(ngModel)]="quote.selected" (change)="sidebarToggleItemSelectionQuote()">
                  <span class="part-name">{{quote.itemName}}</span>
                  <i class="material-icons-spare" (click)="openEditDialog(quote)">edit</i>                  
                </div> -->

                <div class="lines">
                  <!-- {{quote.mrp * quote.itemQuantity}} -->
                  <span class="spare-mrp" style="width: 100%;text-align: end;">₹{{quote.sellingPrice * quote.quantity | number:'1.0-0'}}</span> 
                </div>
                <!-- <div class="lines">
                  <span class="date-time">{{quote.edt | date:'dd MMM yyyy'}}</span>
                </div>  -->
                <hr style="border: 1px solid #ebebeb;" />
                <div class="quantity-control">
                  <div class="brand" style="    width: 71%;
                  color: #999;
                  font-size: 13px;">
                    {{quote.brand}}
                  </div>
                  <div class="addtocartcompatiblecar1">
                    <div class="spare-add-cart1">
                        <div class="btn-group">
                          <div class="new-div">
                              <button class="button1" mat-raised-button  (click)="decrementLabourQuantity(quote)">
                                  <mat-icon class="sidebuttons1" >remove</mat-icon>
                              </button>
                              <!-- <input type="text" [(ngModel)]="cartList[0][list.key].cart_qty" readonly style="height:38px;;text-align: center; width: 40%;"> -->
                              <button  class="button1" mat-raised-button >
                                {{quote.quantity}} 
                              </button>
                              <button class="button2" mat-raised-button (click)="incrementLabourQuantity(quote)">
                                <mat-icon class="sidebutton1"  >add</mat-icon>
                              </button>
                            </div>
                            <!-- <mat-icon class="sidebutton1"  (click)="incrementLabourQuantity(quote)">add</mat-icon> -->
                        </div>
                    </div>
                </div>
                  <!-- <div class="add-minus">
                    <button mat-icon-button (click)="decrementjobcardQuantity(quote)">
                      <mat-icon style="margin-right: 6px;">remove</mat-icon>
                    </button>
                    <span style="padding: 7px;margin-left: 12px;">{{ quote.itemQuantity }}</span>
                    <button mat-icon-button (click)="incrementjobcardQuantity(quote)">
                      <mat-icon>add</mat-icon>
                    </button>
                </div> -->
                </div>
                             <!-- ==================ITEM LEVEL DISCOUNT============== -->
                <form [formGroup]="mainForm">
                  <div formArrayName="quoteFormArray">
                      <!-- <div *ngFor="let quote of customerQuotation; let i = index" > -->
                        
                          <div [formGroupName]="i" class="item-level-discount-mat-form">

                            <mat-form-field appearance="outline" class="item-discount-input">
                              <mat-label>Discount %</mat-label>
                              <input
                              matInput
                              type="number"
                              formControlName="discountPercentage"
                              [disabled]="getControlValue(i, 'discountValue')"
                              (input)="onDiscountPercentageInput(i)"
                            />
                            </mat-form-field>
                            
                            <mat-form-field appearance="outline" class="item-discount-input">
                              <mat-label>Discount ₹</mat-label>
                              <input
                              matInput
                              type="number"
                              formControlName="discountValue"
                              [disabled]="getControlValue(i, 'discountPercentage')"
                              (input)="onDiscountValueInput(i)"
                            />
                            </mat-form-field>

                            
                          </div>
                          <div *ngIf="customerQuotation[i]?.isDiscountInvalid" class="error-text" style="color: red; font-size: 12px;">
                                Discount can't exceed  100%
                          </div>
                       
                      <!-- </div> -->
                  </div>
                  
                </form>
                <!-- <div class="savebtn-div">
                    <button mat-raised-button color="primary" class="discount-save-btn" (click)="saveDiscount(quote)">
                      Save
                    </button>
                  </div> -->
                <!-- ==================ITEM LEVEL DISCOUNT END============== -->
            </div>
          </div>
          </div>
          
          <div class="labour-section-details" *ngIf="selectedItemsLabourQuote?.length>0">
            <div style="padding: 0px 15px; margin-bottom: 40%;">
            <div class="spare-labour-header">
              <h2 style="font-weight: bold;">Labour Charges</h2>
              <p style="margin-top:23px;color:#144579;cursor:pointer;font-weight: bold;" (click)="addLabourSidebar()" >Add More</p>
            </div>
            <div class="quotereceived-items" *ngFor="let quote of selectedItemsLabourQuote" [ngClass]="{'border-box': quote.selected}">
            
                <div class="labour-lines" style="display:flex;">
                  <div>
                  <input type="checkbox" class="checkbox-spare" [(ngModel)]="quote.selected" (change)="toggleItemSelectionLabour()">
                </div>
                <div style="width: 86%;">
                  <span class="part-name">{{quote.labourName}}</span>
                </div>
                <div>
                  <i class="material-icons-spare" (click)="openLabourEditSidebar(quote)">edit</i>
                </div>
                
                
              </div>
              <span class="labour-mrp" >₹{{quote.labourAmount | number:'1.0-0'}}</span>
              <div class="lines">
                <span *ngIf="labourItemsCount > 0" class="date-time">{{quote.edt  | date:'dd MMM yyyy'}}</span>
              </div>
              <hr style="border: 1px solid #c0bebe;" />
              <div class="quantity-control">
                <div class="brand" style=" width: 71%;
                color: #999;
                font-size: 13px;">
                  {{quote.brand}}
                </div>
                <div class="addtocartcompatiblecar1">
                  <div class="spare-add-cart1">
                      <div class="btn-group">
                        <div class="new-div">
                            <button class="button1" mat-raised-button  (click)="decrementLabourQuantity(quote)">
                                <mat-icon class="sidebuttons1">remove</mat-icon>
                            </button>
                            <button  class="button1" mat-raised-button >
                              {{quote.quantity}} 
                            </button>
                            <button class="button2" mat-raised-button (click)="incrementLabourQuantity(quote)">
                              <mat-icon class="sidebutton1"  >add</mat-icon>
                            </button>
                          </div>
                      </div>
                  </div>
              </div>
              </div>

                         <!-- Discount section above the CTA -->
          <div *ngIf="calculatedDiscount > 0 && anyItemSelectedQuote()" class="discount-info-container">
            <div class="discount-label">
                <div  class="percent-badge">%</div>
                <div  style="display: inline; margin-left: 10px;">
                  <span style="color: lightslategrey;">Discount</span>
                  <div style="color: black;font-weight: 700;">₹{{ calculatedDiscount | number:'1.2-2' }}</div>
                </div>
            </div>
            <div class="discount-amount">
              <span class="change-link" (click)="openExtraDiscountBottomSheet()">Change</span>
            </div>
          </div>
          <div *ngIf="calculatedDiscount === 0 && anyItemSelectedQuote()" class="extra-discount-div"(click)="openExtraDiscountBottomSheet()">
            <div class="percent-badge">%</div>
            <button class="extra-discount-btn" type="button">Add Extra Discount</button> 
          </div>
          <!--Discount  Bottom Sheet -->
          <div class="overlay" [class.visible]="showExtraDiscountBottomSheet && anyItemSelectedQuote()" (click)="closePopup()"></div>
            <div class="extra-discount-bottom-sheet" *ngIf="showExtraDiscountBottomSheet">
              <div class="sheet-header">
                <div class="discount-add-text">Add Extra Discount</div>
                <div class="info-material-icon" (click)="toggleInfoPopup()" >
                  <mat-icon>info</mat-icon>
                </div>
                <div (click)="closeExtraDiscountBottomSheet()"><mat-icon>close</mat-icon>
                </div>
              </div>

              <div class="enter-discount-text">Enter Discount In</div>
              <div class="toggle-radio-buttons">
                <label >
                  <input
                    type="radio"
                    name="discountType"
                    value="rupees"
                    [(ngModel)]="discountType"
                  />
                  <span style="color: black; font-weight: 700;">₹</span>
                </label>
              
                <label>
                  <input
                    type="radio"
                    name="discountType"
                    value="percentage"
                    [(ngModel)]="discountType"
                  />
                  <span  style="color: black;">%</span>
                </label>
              </div>
              
              <div class="percent-tab">
                <mat-form-field appearance="outline" class="discount-input-field" style="padding: 0px !important;">
                  <mat-label>Discount in {{ discountType === 'rupees' ? '₹' : '%' }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [(ngModel)]="discountValue"
                    (input)="calculateDiscountPreview(i)" />
                </mat-form-field>
                <mat-error *ngIf="isDiscountInvalid">
                  Discount cannot be greater than {{totalSelectedEditPriceQuote }}.
                </mat-error>
                
              </div>
              
              <div class="dis-and-save">
                <div *ngIf="discountValue > 0" class="discount-preview">
                  <div class="discount-rupees-cal"> ₹ {{ getDiscountAmount() | number:'1.2-2' }} ({{ getDiscountPercentage() | number:'1.2-2' }}% )</div>
                  <div>(Discount will be applied)</div>
                </div>        
                <!-- <div class="save-btn-tab">
                  <button class="save-btn" (click)="saveExtraDiscount()">Save</button>
                </div> -->
                <div class="save-btn-tab" >
                  <button class="save-btn"  [disabled]="isDiscountInvalid" (click)="saveExtraDiscount()">Save</button>
                </div>
              </div>
              
            </div>
            <!-- Info Popup -->
            <div class="overlay" [class.visible]="showInfoPopup" (click)="closePopup()"></div>
              <div class="info-popup" *ngIf="showInfoPopup">
                <div class="popup-header">
                  <span class="popup-title">Extra Discount</span>
                  <mat-icon class="popup-close-icon" (click)="toggleInfoPopup()">close</mat-icon>
                </div>
                <div class="popup-message">
                  Extra discount is directly deducted to the total invoice amount. It does not affect the tax calculations.
                </div>
                <div class="popup-footer">
                  <button class="popup-ok-btn" (click)="toggleInfoPopup()">Okay</button>
                </div>
              </div>
            </div>
          </div>
          </div>

          <!-- <div class="labour-section-details" *ngIf="selectedItemsLabourQuote?.length>0">
          <div class="spare-part-header">
            <h2 style="font-weight: bold;">Labour Charges</h2>
            <p style="margin-top:23px;color:#144579;cursor:pointer;font-weight: bold;" (click)="addLabourSidebar()" >Add More</p>
          </div>
          <div class="quotereceived-items" *ngFor="let quote of selectedItemsLabourQuote" [ngClass]="{'border-box': quote.selected}">
          
              <div class="labour-lines" style="display:flex;">
                <div>
                <input type="checkbox" class="checkbox-spare" [(ngModel)]="quote.selected" (change)="toggleItemSelectionQuote()">
              </div>
              <div style="width: 86%;">
                <span class="part-name">{{quote.labourName}}</span>
              </div>
              <div>
                <i class="material-icons-spare" (click)="openLabourEditSidebar(quote)">edit</i>
              </div>
              
                            <span class="labour-mrp" >₹{{quote.labourAmount | number:'1.0-0'}}</span>
              <div class="lines">
                <span *ngIf="labourItemsCount > 0" class="date-time">{{quote.edt  | date:'dd MMM yyyy'}}</span>
              </div>
              <hr style="border: 1px solid #c0bebe;" />
              <div class="quantity-control">
                <div class="brand" style=" width: 71%;
                color: #999;
                font-size: 13px;">
                  {{quote.brand}}
                </div>
                <div class="addtocartcompatiblecar1">
                  <div class="spare-add-cart1">
                      <div class="btn-group">
                        <div class="new-div">
                            <button class="button1" mat-raised-button  (click)="decrementLabourQuantity(quote)">
                                <mat-icon class="sidebuttons1">remove</mat-icon>
                            </button>
                            <button  class="button1" mat-raised-button >
                              {{quote.quantity}} 
                            </button>
                            <button class="button2" mat-raised-button (click)="incrementLabourQuantity(quote)">
                              <mat-icon class="sidebutton1"  >add</mat-icon>
                            </button>
                          </div>
                      </div>
                  </div>
              </div>
              </div>
            </div>
          </div> -->
          <!-- ===================extra-dicount-section=================== -->

        <!-- </div>

        </div> -->

      <div class="overlay" [class.visible]="isPopupOpenEdit" (click)="closePopupEdit()"></div>
      <div *ngIf="isPopupOpenEdit" [ngClass]="isMobile ? 'bottom-sheetMobile' : 'bottom-sheet'">
        <header class="back-button">
          <div style="flex-direction: column;width: 87%;">
          <h3 class="header-name" style="margin-bottom: 2px;margin-top: -2px;">{{ itemQuote.itemName }}</h3>
          <h3 class="header-name" style="margin-bottom: 2px;margin-top: -2px;font-weight:100;font-size:13px">{{ itemQuote.brand }}</h3>
        </div>
          <mat-icon (click)="closePopupEdit()" class="close-pop-up">close</mat-icon>
        </header>
        <div class="bottom-sheet-content">
        <form [formGroup]="unitPrice" style="width: 100%;
        margin-left: -9px;">
        <div class="unit-price">
          <mat-form-field appearance="outline" class="full-width" class="edit-labour-details">
            <mat-label>Unit Price</mat-label>
            <input
              matInput
              formControlName="unitprice"                            
              [(ngModel)]="itemQuotesEdit.sellingPrice"
              placeholder="Enter Unit Price*"
              required
              name="Unit Price"
              pattern="^[0-9]*$"
            />
            </mat-form-field>
        </div>
      </form>
        <div class="item-update" style="bottom: -15px;height: 50px;">
          <button class="item-update-btn" style="margin-top:0px;" (click)="save()">Save Quote</button>
        </div>
        </div>
      </div>
      <ng-template #noQuotesApproved>
        <div class="empty-state">
          <div >
            
            <img src="../../../../assets/images/request-details images/requestdetailsimage.png" alt="Quote Not Approved" class="quote-image">
            <div class="message">
              <strong>Invoice Not Created Yet!</strong>
              <p>Create Invoice</p>
            </div>
          </div>
        </div>
        <!-- <button class="approveNow" (click)="approveNow()" *ngIf="activeTabs === 'quotation'">APPROVE QUOTE NOW</button> -->
      </ng-template>
        </div>
        <div class="floater-btn" (click)="AddItems()" *ngIf="customerQuotation?.length > 0 && selectedItemsLabourQuote?.length == 0">
          <p style="font-weight: bold;">ADD ITEM</p>
        </div>
        <!-- Add Item Side Bar -->

        <div class="overlay" [class.visible]="newItem" (click)="createNewItems()" ></div>
        <div class="custom-sidebar" *ngIf="newItem">
          <button mat-icon-button class="back-buttonNew" (click)="createNewItems()" >
            <mat-icon>arrow_back</mat-icon>
          </button>
        
          <div class="content">
            <div class="image-container">
              <img  src="../../../../assets/images/car-repair.png" alt="car-repair">
            </div>
            
            <p class="title">Can't find what you are looking for?</p>
            <p class="subtitle" *ngIf="searchWord.length>0">Create {{searchWord}}</p>
            
          </div>
          <div class="fixedCTA">
            <button mat-button class="primary-btn" (click)="createItemSidebar()">CREATE ITEM</button>
          </div>
        </div>

        <!-- Add Labour -->
        <div *ngIf="isAddLabour" class="labour-sidebar">
        <div class="labour-section">
            <div class="labour-maticon" >
              <mat-icon (click)="labourRedirectSidebar()">arrow_back</mat-icon>
            </div>
            <div class="labour-header" >
              <h2>Add Labour</h2>
            </div>
            <div class="labour-skip" >
              <p style="position: relative;float:right;padding:10px;cursor:pointer;color:#144579;"(click)="openSkipConfirmation()">Skip</p>
            </div>
          </div>
          <div class="search-bar">
            <input
              type="text"
              placeholder="Search Labour"
              [(ngModel)]="searchText"
              class="search-input"
              (input)="onLabourSearch()"/>
      
            <button *ngIf="searchText" class="clear-btn" (click)="clearLabourSearch()">&#x2715;</button>
          </div>
          <div class="item-list1">
          <!-- Labour List -->
          <div *ngFor="let labour of labourListData" class="dropdown-item">
            <div class="checkboxselect-labour">
              <input 
                type="checkbox" 
                [(ngModel)]="labour.selected" 
                (change)="onLabourSelectionChange(labour)"
              />
            </div>
            <div class="dropdown-details">
              <h4>{{ labour.labourName }}</h4>
              <div class="item-price">
                <p>₹{{ labour.labourAmount }}</p>
              </div>

            </div>
            <div class="edit-btn">
              <i class="material-icons" (click)="openLabourEditSidebar(labour)">edit</i>
            </div>
          </div>
          
            <div class="floater-labour-btn" (click)="openLabourEditSidebar()">
              <p>ADD LABOUR</p>
            </div>
        </div>
            <!-- Skip Confirmation Popup -->
            <div class="skip-confirmation" *ngIf="showSkipConfirmation">
              <!-- <button class="cancel-popup-close" (click)="closeSkipConfirmation()">×</button> -->
              <p class="skip-text">Are you sure you want to skip Adding Labour?</p>
              <button class="cancel-popup-btn no-btn" (click)="closeSkipConfirmation()">No</button>
              <button class="cancel-popup-btn confirm-btn" (click)="openPopup()">Yes</button>
              
            </div>
            <div 
              *ngIf="selectedLabourCount > 0 || selectedNewLabours > 0" 
                [ngClass]="isMobile?'bottom-boxQuoteMobile':'bottom-boxQuote'">
                  <div class="bottom-contentQuote">
                    <div class="total-items">{{ selectedLabourCount }} items
                      <p class="total-amount">₹{{totallabourListSelectedPrice  | number:'1.0-0' }}</p>
                  
                  </div>
                    <button type="button" class="add-labour-bottom-cta" (click)="toggleSelectItem()">Add Labour</button>
                </div>
            </div>
        </div>
          <div *ngIf="customerQuotation?.length == 0" (click)="AddItems()" class="quotation-bottom-ctaInvoice" >
            <button class="quotation-bottom-cta">Add Invoice Items</button>
          </div>


          <div *ngIf="anyItemSelectedQuote() || anyItemSelected() || selectedItemsCountQuote>0 " [ngClass]="isMobile ? 'bottom-boxQuoteMobile':'bottom-boxQuote'">
          <!-- <div *ngIf="anyItemSelectedQuote() && customerQuotation?.length>0 && !selectedItemsLabourQuote" [ngClass]="isMobile ? 'bottom-boxQuoteMobile':'bottom-boxQuote'"> -->
              <div class="bottom-contentQuote">
                <div class="total-items">{{selectedItemsCount}} items
                  <p class="total-amount">₹{{sparePartsTotalcreation - calculatedDiscount | number:'1.0-0'}}</p>
                  <!-- <p *ngIf="activeTab === 'quote-approved'" class="total-amount">₹{{quoteApprovedPrice | number:'1.2-2' }}</p> -->
                </div>
                <div class="in-next-step">
                <button class="add-labour-bottom-btn1" 
                  *ngIf="sparePartsTotalcreation > 0 || selectedItemsLabourQuote?.length== 0" 
                  type="button" 
                  (click)="addLabourSidebar()">
                  Add Labour
                  <span class="next-step-text">(In Next Step)</span>
                </button>
              </div>
              </div>  
          </div>
                                   <!-- Discount section above the CTA -->
                                   <div *ngIf="calculatedDiscount > 0 && anyItemSelectedQuote()" class="discount-info-container">
                                    <div class="discount-label">
                                        <div  class="percent-badge">%</div>
                                        <div  style="display: inline; margin-left: 10px;">
                                          <span style="color: lightslategrey;">Discount</span>
                                          <div style="color: black;font-weight: 700;">₹{{ calculatedDiscount | number:'1.2-2' }}</div>
                                        </div>
                                    </div>
                                    <div class="discount-amount">
                                      <span class="change-link" (click)="openExtraDiscountBottomSheet()">Change</span>
                                    </div>
                                  </div>
                                  <div *ngIf="calculatedDiscount === 0 && anyItemSelectedQuote()" class="extra-discount-div"(click)="openExtraDiscountBottomSheet()">
                                    <div class="percent-badge">%</div>
                                    <button class="extra-discount-btn" type="button">Add Extra Discount</button> 
                                  </div>
                                  <!--Discount  Bottom Sheet -->
                                  <div class="overlay" [class.visible]="showExtraDiscountBottomSheet && anyItemSelectedQuote()" (click)="closePopup()"></div>
                                    <div class="extra-discount-bottom-sheet" *ngIf="showExtraDiscountBottomSheet">
                                      <div class="sheet-header">
                                        <div class="discount-add-text">Add Extra Discount</div>
                                        <div class="info-material-icon" (click)="toggleInfoPopup()" style="    width: 44%;">
                                          <mat-icon>info</mat-icon>
                                        </div>
                                        <div (click)="closeExtraDiscountBottomSheet()"><mat-icon>close</mat-icon>
                                        </div>
                                      </div>
                        
                                      <div class="enter-discount-text">Enter Discount In</div>
                                      <div class="toggle-radio-buttons">
                                        <label >
                                          <input
                                            type="radio"
                                            name="discountType"
                                            value="rupees"
                                            [(ngModel)]="discountType"
                                            
                                          />
                                          <span style="color: black; font-weight: 700;">₹</span>
                                        </label>
                                      
                                        <label>
                                          <input
                                            type="radio"
                                            name="discountType"
                                            value="percentage"
                                            [(ngModel)]="discountType"
                                           
                                          />
                                          <span  style="color: black;">%</span>
                                        </label>
                                      </div>
                                      
                                      <div class="percent-tab">
                                        <mat-form-field appearance="outline" class="discount-input-field" style="padding: 0px !important;">
                                          <mat-label>Discount in {{ discountType === 'rupees' ? '₹' : '%' }}</mat-label>
                                          <input
                                            matInput
                                            type="number"
                                            [(ngModel)]="discountValue"
                                            (input)="calculateDiscountPreview(i)" />
                                        </mat-form-field>
                                        <mat-error *ngIf="isDiscountInvalid">
                                          Discount cannot be greater than {{totalSelectedEditPriceQuote }}.
                                        </mat-error>
                                        
                                      </div>
                                      
                                      <div class="dis-and-save">
                                        <div *ngIf="discountValue > 0" class="discount-preview">
                                          <!-- <div class="discount-rupees-cal"> ₹ {{ getDiscountAmount('rupees') | number:'1.2-2' }} ({{ getDiscountPercentage('percentage') | number:'1.2-2' }}% )</div> -->
                                          <div class="discount-rupees-cal">
                                              ₹ {{ getDiscountAmount(discountType) | number:'1.2-2' }} 
                                              ({{ getDiscountPercentage(discountType) | number:'1.2-2' }}%)
                                            </div>

                                          <div>(Discount will be applied)</div>
                                        </div>        
                                        <!-- <div class="save-btn-tab">
                                          <button class="save-btn" (click)="saveExtraDiscount()">Save</button>
                                        </div> -->
                                        <div class="save-btn-tab" >
                                          <button class="save-btn"  [disabled]="isDiscountInvalid" (click)="saveExtraDiscount()">Save</button>
                                        </div>
                                      </div>
                                      
                                    </div>
                                    <!-- Info Popup -->
                                    <div class="overlay" [class.visible]="showInfoPopup" (click)="closePopup()"></div>
                                      <div class="info-popup" *ngIf="showInfoPopup">
                                        <div class="popup-header">
                                          <span class="popup-title">Extra Discount</span>
                                          <mat-icon class="popup-close-icon" (click)="toggleInfoPopup()">close</mat-icon>
                                        </div>
                                        <div class="popup-message">
                                          Extra discount is directly deducted to the total invoice amount. It does not affect the tax calculations.
                                        </div>
                                        <div class="popup-footer">
                                          <button class="popup-ok-btn" (click)="toggleInfoPopup()">Okay</button>
                                        </div>
                                      </div>
          <div *ngIf="(anyItemSelectedQuote() || anyItemSelected()) && customerQuotation?.length>0 && selectedItemsLabourQuote?.length>0" [ngClass]="isMobile ? 'bottom-boxQuoteMobile':'bottom-boxQuote'">
            <div class="bottom-contentQuote">
              <div class="total-items">{{selectedItemsCount}} items 
                <p class="total-amount">₹{{ (totalInvoicePrice - calculatedDiscount) | number:'1.0-0'}}</p>
                <!-- <p *ngIf="activeTab === 'quote-approved'" class="total-amount">₹{{quoteApprovedPrice | number:'1.2-2' }}</p> -->
              </div>

              <button class="create-quote-btn" *ngIf="isGstDetailsPresent == true" type="button" 
                (click)="openPopup()">Create Invoice</button>

                
                <button class="create-quote-btn" *ngIf="isGstDetailsPresent == false" type="button" 
                (click)="openPopUpGst()">Create Invoice</button>
                

      
            </div>  
        </div>
        </div>
        <!-- Edit labour name Sidebar -->
        <div class="overlay" [class.visible]="isEditLabourSidebarOpen" (click)="closeAll()"></div>
        <!-- <div *ngIf="isEditLabourSidebarOpen" class="edit-labour-sidebar">
          <div class="labour-sidebar-header">
            <h2>Edit Labour</h2>
            <mat-icon (click)="closeLabourEditSidebar()">close</mat-icon>
          </div>
          <form [formGroup]="laborDetails" >
              <div class="labour-name-column" style="margin-top: -8px;">
                <mat-form-field appearance="outline" class="full-width" class="edit-labour-details" style="margin-top: 10px;">
                <mat-label>Labour Name</mat-label>
                <input
                  matInput
                  formControlName="labourName"
                  [(ngModel)]="selectedLabour.labourName"
                  placeholder="Enter Labour Name"
                  name="labourName"
                />
                </mat-form-field>
              </div>
              <div class="laboue-price-column" style="margin-top: -14px;">
                <mat-form-field appearance="outline" class="edit-labour-details">
                  <mat-label>Labour Amount</mat-label>
                  <input
                    matInput
                    formControlName="labourAmount"
                    [(ngModel)]="selectedLabour.labourAmount"
                    placeholder="Enter Labour Amount"
                    name="labourPrice"
                  />
                </mat-form-field>
              </div>  
          </form>
         
          <div class="item-update" style="margin-top: -14px;">
            <button class="item-update-btn" *ngIf="selectedLabour?.id || selectedLabour?.labourId" (click)="saveLabour()">Save Labour</button>
      <button class="item-update-btn" *ngIf="!(selectedLabour?.id || selectedLabour?.labourId)" (click)="addLabour()">Add Labour</button>
       </div>
          
        </div> -->
        
        <div *ngIf="isEditLabourSidebarOpen" class="edit-labour-sidebar">
          <div class="labour-sidebar-header">
            <h2>{{ selectedLabour?.id || selectedLabour?.labourId ? 'Edit Labour' : 'Add Labour' }}</h2>
            <mat-icon (click)="closeLabourEditSidebar()" style="margin-right: 0px;">close</mat-icon>
          </div>
        
          <form [formGroup]="laborDetails" style="width: 353px;float: left;margin-left: -8px;">
            <div class="labour-name-column" style="margin-top: -8px;margin-left: -17px;">
              <mat-form-field appearance="outline" class="full-width" style="margin-top: 10px;width:100%">
                <mat-label>Labour Name</mat-label>
                <input
                  matInput
                  formControlName="labourName"
                  [(ngModel)]="selectedLabour.labourName"
                  placeholder="Enter Labour Name"
                  name="labourName"
                />
              </mat-form-field>
            </div>
        
            <div class="laboue-price-column" style="margin-top: -8px;margin-left: -17px;">
              <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Labour Amount</mat-label>
                <input
                  matInput
                  formControlName="labourAmount"
                  [(ngModel)]="selectedLabour.labourAmount"
                  placeholder="Enter Labour Amount"
                  name="labourPrice"
                />
              </mat-form-field>
            </div>
          </form>
        
          <div class="item-update" style="margin-top: -14px;">
            <button class="item-update-btn" *ngIf="selectedLabour?.id || selectedLabour?.labourId" (click)="saveLabour()">Save Labour</button>
      <button class="item-update-btn" *ngIf="!(selectedLabour?.id || selectedLabour?.labourId)" (click)="addLabour()">Add Labour</button>
          </div>
        </div>
        
        <!-- Popup for skip labour -->
          <!-- <div class="cancel-popup-container" *ngIf="showCancelConfirmation">
            <div class="cancel-popup">
              <button class="cancel-popup-close" (click)="closeCancelPopup()">×</button>
              <p>Are you sure you want to skip?</p>
              <button class="cancel-popup-btn confirm-btn" (click)="confirmAction()">Yes</button>
              <button class="cancel-popup-btn no-btn" (click)="closeCancelPopup()">No</button>
            </div>
         </div> -->
    </mat-list>
  
  </div>
  <div class="overlay" [class.visible]="newItems" (click)="createItemSidebar()" ></div>

  <mat-sidenav-container class="sidebar-containerNew" *ngIf="newItems">
    <mat-sidenav #sidenav mode="side" class="custom-sidebar" [(opened)]="newItems">
      <div class="sidebar-header">
        <!-- <mat-icon style="margin-top: 0px;" (click)="newItems = false">arrow_back</mat-icon>
        <h3>Create Item</h3> -->
        <div class="sidebar-header">
              <div *ngIf="!searchActive" class="header-normal">
                <mat-icon style="margin-top: 0px;" (click)="newItems = false">arrow_back</mat-icon>
                <h3>Create Item</h3>
                <mat-icon class="search-toggle" (click)="toggleTopSearchBar()">search</mat-icon>
              </div>
              <div *ngIf="searchActive" class="header-search">
                <div class="search-container" style="    padding: 10px 0px 10px 0px;">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input type="text" placeholder="Search..."  class="search-input-new"
                      [(ngModel)]="searchText"
                      (input)="filterSuggestions()" />
                  <mat-icon class="close-icon" (click)="toggleTopSearchBar()">close</mat-icon>
                   <!-- 🟨 Suggestion Dropdown -->
                <ul class="suggestion-list" *ngIf="suggestions.length > 0">
                  <li *ngFor="let item of suggestions" (click)="onPartSelected(item.type === 'partNumber' ? item.value : null)">
                    {{ item.value }}
                  </li>
                </ul>
                </div>
              </div>
        </div>
      </div>
      <div class="sidebar-content">
        <form [formGroup]="itemForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Item Name *</mat-label>
            <!-- <input matInput formControlName="itemName"> -->
             <input matInput formControlName="itemName" (input)="onItemNameInput($event.target.value)" (blur)="hideSuggestions()"
                    (focus)="showSuggestions()"
                    autocomplete="off" >
            <mat-error *ngIf="itemForm.get('itemName')?.invalid && itemForm.get('itemName')?.touched">
              Item Name is required
            </mat-error>
              <!-- Suggestions dropdown -->
                    <div
                      *ngIf="showSuggestionList && itemSuggestions.length > 0"
                      class="suggestions-dropdown"
                    >
                      <div
                        class="suggestion-item"
                        *ngFor="let item of itemSuggestions"
                        (mousedown)="selectItem(item)"
                      >
                        {{ item.name }}
                      </div>
                    </div>
          </mat-form-field>
        
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Part Number *</mat-label>
            <input matInput formControlName="partNumber">
            <mat-error *ngIf="itemForm.get('partNumber')?.invalid && itemForm.get('partNumber')?.touched">
              Part Number is required
            </mat-error>
          </mat-form-field>
        
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Brand *</mat-label>
            <input matInput formControlName="brand">
            <mat-error *ngIf="itemForm.get('brand')?.invalid && itemForm.get('brand')?.touched">
              Brand is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>GST% *</mat-label>
            <mat-select formControlName="gst">
              <mat-select [(value)]="selectedGst">
                <mat-option *ngFor="let gst of gstOptions" [value]="gst">
                  GST {{ gst }}%
                </mat-option>
              </mat-select>
            </mat-select>
            <mat-error *ngIf="itemForm.get('gst')?.invalid && itemForm.get('gst')?.touched">
              Select GST%
            </mat-error>
          </mat-form-field>
        
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>HSN *</mat-label>
            <input matInput formControlName="hsn" >
            <mat-error *ngIf="itemForm.get('hsn')?.invalid && itemForm.get('hsn')?.touched">
              Enter a valid HSN (4-8 digits)
            </mat-error>
          </mat-form-field>
        
      
          <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 128px;">
            <mat-label>Unit Price *</mat-label>
            <input matInput formControlName="unitPrice">
            <mat-error *ngIf="itemForm.get('unitPrice')?.invalid && itemForm.get('unitPrice')?.touched">
              Enter a valid Unit Price 
            </mat-error>
          </mat-form-field>
          <div class="fixedCTA" style="width: 29%;right: 18px;" >
          <button mat-flat-button color="primary" class="primary-btn" type="submit" >
            Create Item
          </button>
        </div>
        </form>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>

  <div *ngIf="isSidebarOpen" class="new-sidebar">
    <div class="header1">
      <div class="maticon">
      <mat-icon (click)="toggleSidebar()">arrow_back</mat-icon>
    </div>
    <div class="add-items">
      <h3 style="font-weight: bold;margin-right:215px;margin-bottom:20px;">Add Items</h3>
    </div>
    </div>
    <div class="search-bar">
      <input
        type="text"
        placeholder="Search by Part Name"
        [(ngModel)]="searchWord"
        class="search-input"
        (input)="onSearch()"
      />
      <button *ngIf="searchWord" class="clear-btn" (click)="clearSearch()">&#x2715;</button>
    </div>
    
    <div class="item-list">
      <div *ngFor="let item of filteredItems" class="dropdown-item" (click)="addItemToQuotation(item)">
        <img [src]="item.imageUrl" alt="{{ item.partName }}" class="dropdown-image" />
        <div class="dropdown-details" style="width: 100%;">
          <h4>{{ item.name }}</h4>
          <p>Brand: {{ item.brand }}</p>
          <div class="item-price1">
            <p>₹{{item.mrp }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="cantFind" (click)="createNewItems()" >
      <p>Can't Find Your Item?</p>
      <!-- <button mat-icon-button class="arrow-button"> -->
        <mat-icon style="font-size: 15px;" class="arrow_forward">arrow_forward</mat-icon>
      <!-- </button> -->
    </div>
    
  </div>
  
  <div class="overlay" [class.visible]="PopupOpen" (click)="closePopup()"></div>

  <div class="popup" *ngIf="PopupOpen">
    <div class="popup-content order-success-sec">
        <i class="material-icons" class="close-btn" (click)="closePopup()">close</i>
        <h3>You have pending quote items. Are you sure you want to proceed?</h3>
        <div class="popup-buttons">
          <button class="no-btn" (click)="closePopup()">No</button>
          <button class="yes-btn" (click)="updateInfo()">Yes</button>
        </div>
    </div>
  </div>
  <div *ngIf="isPopupOpen" class="popup">
    <div class="popup-content">
      <mat-icon style="float: right; cursor: pointer;" (click)="closePopup()">close</mat-icon>
      <img src="{{successIcon}}" alt="successIcon" style="width: 36%;">
      <h3 *ngIf="resData?.invoiceId === null || resData?.invoiceId === 'null'">Invoice Created</h3>
      <h3 *ngIf="resData?.invoiceId !== null && resData?.invoiceId !== 'null'">Invoice Created</h3>
      <p class="order-label" *ngIf="resData?.invoiceId === null || resData?.invoiceId === 'null'">
        <span class="order-id">Invoice id {{ resData?.invoiceId }}</span>
      </p>
      <p class="order-label" *ngIf="resData?.invoiceId !== null && resData?.invoiceId !== 'null'">
        <span class="order-id">Invoice id {{ resData?.invoiceId }}</span>
      </p>
      <p class="date"><span>{{resData?.createdAt | date:'dd MMM yyyy, h:mm a': 'GMT+1060'}}</span></p>
      <p class="thank you">You have successfully created Invoice</p>
    
      <button class="goto-order" *ngIf="resData?.invoiceId === null || resData?.invoiceId === 'null'" (click)="navigateToDetails( resData.invoiceId)">View Customer Invoice</button>
      <button class="goto-order" *ngIf="resData?.invoiceId !== null && resData?.invoiceId !== 'null'" (click)="navigateToDetails(resData.invoiceId)">View Customer Invoice</button>
    </div>
  </div>
  <div *ngIf="isPopupOpen" class="popup">
    <div class="popup-content">
      <div style="float: right; margin-right: 0px;">
        <mat-icon (click)="closePopup()" >close</mat-icon>
      </div>
    <img src="{{successIcon}}" alt="successIcon" style="width: 36%;">
    <h3 *ngIf="resData?.invoiceId === null || resData?.invoiceId === 'null'">Invoice Created</h3>
    <h3 *ngIf="resData?.invoiceId !== null && resData?.invoiceId !== 'null'">Invoice Created</h3>
    <p class="order-label" *ngIf="resData?.invoiceId === null || resData?.invoiceId === 'null'">
      <span class="order-id">Invoice id {{ resData?.invoiceId }}</span>
    </p>
    <p class="order-label" *ngIf="resData?.invoiceId !== null && resData?.invoiceId !== 'null'">
      <span class="order-id">Invoice id {{ resData?.invoiceId }}</span>
    </p>
    <p class="date"><span>{{resData?.createdAt | date:'dd MMM yyyy, h:mm a': 'GMT+1060'}}</span></p>
    <p class="thank you">You have successfully created Invoice</p>
  
    <button class="goto-order" *ngIf="resData?.invoiceId === null || resData?.invoiceId === 'null'" (click)="navigateToDetails( resData.invoiceId)">View Customer Invoice</button>
    <button class="goto-order" *ngIf="resData?.invoiceId !== null && resData?.invoiceId !== 'null'" (click)="navigateToDetails(resData.invoiceId)">View Customer Invoice</button>
  </div>
    </div>
</div>
  
<ng-container #vehicleServiceHistoryContainer></ng-container>

<div #dynamicContainer1></div>

<!-- GST Side Slider -->
<div class="overlay-gst" [class.visible]="gstDetails" (click)="closeAll()" ></div>
<div *ngIf="gstDetails && isGstDetailsPresent == false" class="gst-side-slider">
  <div class="gst-slider-header">
      <mat-icon class="back-btn" (click)="closeGstSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Business Account</div>
          <!-- <span class="skip-text" (click)="skipForNow()">Skip for now</span> -->
      </div>
  </div>

  <div class="gst-slider-content">
      <div class="subtext-and-h3">
          <h3>Do you have GST number?</h3>
          
      </div>
      <div class="sub-text">15-digit GSTIN Number.</div>

      <!-- Radio Buttons -->
      <div class="radio-group">
        <label class="radio-container" [ngClass]="{'selected': hasGst === true}">
            <input type="radio" name="gst" [(ngModel)]="hasGst" [value]="true">
            Yes, I have GST Number
            <span class="custom-radio"></span>
        </label>

        <label class="radio-container" [ngClass]="{'selected': hasGst === false}">
            <input type="radio" name="gst" [(ngModel)]="hasGst" [value]="false">
            I don’t have GST Number
            <span class="custom-radio"></span>
        </label>
      </div>

  </div>
  <div class="slider-footer" *ngIf="hasGst === false">
    <button class="continue-btn" (click)="continueNextStep1()" [disabled]="hasGst === null">Continue</button>
</div>

  <div class="slider-footer" *ngIf="hasGst === true">
      <button class="continue-btn" (click)="continueNextStep()" [disabled]="hasGst === null">Continue</button>
  </div>
</div>

<!-- Second GST Slider (Hidden by Default) -->
<div class="overlay-gst" [class.visible]="showGstSecondSlider" (click)="closeAll()" ></div>
<div *ngIf="showGstSecondSlider" class="gst-second-slider">
  <div class="gst-slider-header">
      <mat-icon class="back-btn" (click)="closeSecondSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Business Account</div>
          <!-- <span class="skip-text" (click)="skipForNow()">Skip for now</span> -->
      </div>
  </div>

  <div class="gst-2nd-slider-content">
      <h3>Enter GST number</h3>
      <div class="sub-text">Your 15-digit GSTIN</div>

      <!-- GST Input Field -->
      <form [formGroup]="customerGstForm">
        <mat-form-field appearance="outline" class="gst-input-field" style="padding: 0px 20px;">
          <mat-label>Enter GST Number</mat-label>
          <input
            matInput
            formControlName="gstNumber"
            maxlength="15"
            (input)="validateGstInput()"
            required
          >
          <mat-error *ngIf="customerGstForm.get('gstNumber')?.hasError('required')">
            GST Number is required
          </mat-error>
          <!-- <mat-error *ngIf="customerGstForm.get('gstNumber')?.hasError('pattern')">
            GST Number must be 15 characters (A-Z & 0-9)
          </mat-error> -->
        </mat-form-field>
      </form>
      
    
    <!-- </form> -->
    
  </div>

  <div class="slider-footer">
    <button class="continue-btn"
            (click)="openBusinessSlider()"
            [disabled]="customerGstForm.get('gstNumber')?.hasError('required') || customerGstForm.get('gstNumber')?.value.length < 15">
      Continue
    </button>
  </div>
  
</div>

<!-- ================== gst 3nd-section-business-section============== -->
<div class="overlay-gst" [class.visible]="showBusinessInfoSlider" (click)="closeAll()" ></div>
<div *ngIf="showBusinessInfoSlider" class="business-info-slider">
  <div class="business-slider-header">
      <mat-icon class="back-btn" (click)="closeBusinessSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Business Info</div>
      </div>
  </div>

  <div class="business-slider-content">
      <h3>Business Information</h3>
<form [formGroup] = "customerGstForm">
      <!-- Business Name Field -->
      <mat-form-field appearance="outline" class="business-input-field">
        <mat-label>Business/Company Name</mat-label>
        <input matInput formControlName="businessName" required>
        <mat-error *ngIf="customerGstForm.get('businessName')?.hasError('required')">
          Business Name is required
        </mat-error>
      </mat-form-field>

      <!-- GST Input Field -->
      <mat-form-field appearance="outline" class="gst-input-field">
          <mat-label>GST Number (Optional)</mat-label>
          <input matInput formControlName="gstNumber" (input)="validateGstInput()" maxlength="15">
      </mat-form-field>

      <!-- Choose State Field -->
      <mat-form-field appearance="outline" class="state-input-field">
        <mat-label >Choose your State</mat-label>
        <input
          matInput
          formControlName="state"
          readonly
          (click)="openStateSlider()"
          required
          style="background-color: white; border: none; padding: 0px; cursor: pointer;"
        >
        <mat-error *ngIf="customerGstForm.get('state')?.hasError('required') || !customerGstForm.get('state')?.value">
          State is required
        </mat-error>
      </mat-form-field>
</form>
  </div>

  <div class="slider-footer-business">
    <button class="continue-btn-business"
            (click)="openAddressSlider()"
            [disabled]="customerGstForm.invalid">
      Continue
    </button>
  </div>

</div>

<!-- State Selection Sideslider -->
<div class="overlay-gst" [class.visible]="stateSliderOpen" (click)="closeAll()" ></div>
<div class="state-sideslider-overlay" *ngIf="stateSliderOpen">
  <div class="state-sideslider">
    <div class="state-sideslider-header">
      <mat-icon class="back-btn1" (click)="closeStateSlider()">keyboard_backspace</mat-icon>
      <h3 >Select State</h3>
      <mat-icon (click)="closeStateSlider()" style="cursor: pointer;">close</mat-icon>
    </div>

    <!-- Search Bar -->
    <div class="state-SearchBarContainerNew">
      <div class="state-SearchBarButton">
        <div class="state-SearchBarIcon">
          <i class="material-icons-search-state">search</i>
        </div>
        <input
          type="text"
          placeholder="Search for States"
          [(ngModel)]="searchText"
          (input)="filterStates()"
          class="state-SearchBarInput"
        />
        <div class="remove-search-suggestion-state" *ngIf="filteredStates.length" (click)="clearStateSearch()">
          <mat-icon>close</mat-icon>
        </div>
      </div>
    </div>

    <!-- Filtered State List -->
    <div class="state-list">
      <div *ngFor="let state of filteredStates" class="state-item" (click)="selectState(state)">
        {{ state.name }} <!-- Ensure 'name' matches the actual field in API response -->
      </div>
    </div>
  </div>
</div>

<!-- Address Slider -->
<div class="overlay-gst" [class.visible]="showAddressSlider" (click)="closeAll()" ></div>
<div *ngIf="showAddressSlider" class="address-slider">
  <div class="address-slider-header">
    <mat-icon class="back-btn" (click)="closeAddressSlider()">keyboard_backspace</mat-icon>
    <div class="getstarted-header">
      <div class="getstardet-text">Address</div>
    </div>
  </div>

  <div class="address-slider-content">
    <h3>Enter Address</h3>

    <!-- ✅ Form starts here -->
    <form [formGroup]="addressForm" (ngSubmit)="saveAddressDetails()">
      <!-- Address Line 1 -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="addressLine1">
        <mat-error *ngIf="af.addressLine1.hasError('required')">Address Line 1 is required</mat-error>
      </mat-form-field>

      <!-- Address Line 2 -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="addressLine2">
        <mat-error *ngIf="af.addressLine2.hasError('required')">Address Line 2 is required</mat-error>
      </mat-form-field>

      <!-- Pincode -->
      <!-- <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" maxlength="6" required>
        <mat-error *ngIf="af.pincode.hasError">Pincode is required</mat-error>
        <mat-error *ngIf="af.pincode.hasError('pattern')">Enter a valid 6-digit pincode</mat-error>
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" maxlength="6">
        <mat-error *ngIf="af.pincode.touched && af.pincode.hasError('pattern')">
          Enter a valid 6-digit pincode
        </mat-error>
      </mat-form-field>
      

      <!-- City -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="city">
        <mat-error *ngIf="af.city.hasError('required')">City is required</mat-error>
      </mat-form-field>

      <!-- ✅ Submit Button should be inside the form -->
      <div class="slider-footer-Address" (click)="cretaeInvoicePopUP()">
        <button class="continue-btn" type="submit">Continue</button>
      </div>
    </form>
  </div>
</div>
